// extracted by mini-css-extract-plugin
export var container = "_8m-0";